import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';

// Full-page 2FA gate rendered by AdminUserProvider when GET /me returns
// 403 2fa-required. Mirrors the LoginScreen pattern so nothing from the
// authenticated app tree needs to be mounted yet.
// Props:
//   onSubmit(token) → Promise  called with the entered code; rejects on bad code
//   onCancel()                 redirects back to the login page
class TwoFactorScreen extends Component {
  state = {
    token: '',
    loading: false,
    error: '',
  };

  onChange = (e) =>
    this.setState({ token: e.target.value.replace(/\D/g, ''), error: '' });

  submit = async (e) => {
    e.preventDefault();
    const { token, loading } = this.state;
    if (loading || !token) return;

    this.setState({ loading: true, error: '' });
    try {
      await this.props.onSubmit(token);
      // On success the parent retries /me and unmounts this screen.
      // Leave loading:true so there's no flash of the form before unmount.
    } catch (err) {
      this.setState({
        loading: false,
        error:
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          'Invalid code. Please try again.',
      });
    }
  };

  render() {
    const { token, loading, error } = this.state;

    return (
      <div
        className="full-page"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          background: '#1a1a2e',
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} sm={8} md={6} lg={4}>
              <div className="text-center mb-3">
                <h3 className="text-white">BUYPOWER</h3>
                <p className="text-white">Two-factor authentication</p>
              </div>
              <Card>
                <CardBody>
                  <Form onSubmit={this.submit}>
                    {error ? <Alert color="danger">{error}</Alert> : null}
                    <FormGroup>
                      <Label for="2fa-token">Authenticator code</Label>
                      <Input
                        id="2fa-token"
                        type="text"
                        inputMode="numeric"
                        autoFocus
                        autoComplete="one-time-code"
                        value={token}
                        disabled={loading}
                        onChange={this.onChange}
                      />
                    </FormGroup>
                    <Button
                      color="primary"
                      block
                      type="submit"
                      disabled={loading || !token}
                    >
                      {loading ? 'Verifying…' : 'Verify'}
                    </Button>
                    <Button
                      color="link"
                      block
                      className="mt-2"
                      disabled={loading}
                      onClick={this.props.onCancel}
                    >
                      Back to login
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default TwoFactorScreen;
